import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation, useParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import Moment from 'moment';
import 'moment/locale/pt-br';
import { endpointState } from '../../recoil/atoms';

import BitButton from '../../components/BitButton/BitButton';

import BitHeaderFull from '../../components/BitHeader/BitHeaderFull';
import BitPage from '../../components/BitPage/BitPage';
import BitInput from '../../components/BitInput/BitInput';
import BitLinkButton from '../../components/BitLinkButton/BitLinkButton';

const UpdateCommonArea: React.FC = () => {
	Moment.locale('pt-br');

	type typeResponseAxios = {
		[key: string]: any;
	};

	interface ParamTypes {
		idRegister: string;
	}

	const { idRegister } = useParams<ParamTypes>();

	const { urlEndpoint } = useRecoilValue(endpointState);
	const urlEndpointUpdate = `${urlEndpoint}/calendars/update/${idRegister}`;
	const urlEndpointGet = `${urlEndpoint}/calendars/${idRegister}`;
	const urlEndpointGetBlocks = `${urlEndpoint}/calendars/${idRegister}/blocks`;
	const urlEndpointCreateBlock = `${urlEndpoint}/calendars/${idRegister}/blocks`;
	const urlEndpointGetIntervals = `${urlEndpoint}/calendars/${idRegister}/intervals`;
	const urlEndpointCreateInterval = `${urlEndpoint}/calendars/${idRegister}/intervals`;
	const urlEndpointGetFakeIntervals = `${urlEndpoint}/calendars/${idRegister}/fixed-intervals`;

	const token = localStorage.getItem('token');

	const [development, setDevelopment] = useState({
		value: '',
		id: 0,
		required: true,
	});

	const [nome, setNome] = useState({
		value: '',
		required: true,
	});
	const [tempoDuracao, setTempoDuracao] = useState({
		value: '',
		required: true,
	});
	const [descricao, setDescricao] = useState({
		value: '',
		required: false,
	});
	const [horarioInicio, setHorarioInicio] = useState({
		value: '',
		required: true,
	});
	const [horarioFim, setHorarioFim] = useState({
		value: '',
		required: true,
	});
	const [dataInicio, setDataInicio] = useState({
		value: '',
		required: false,
	});
	const [dataFim, setDataFim] = useState({
		value: '',
		required: false,
	});
	const [intervalo, setInterval] = useState({
		value: '0',
		required: false,
	});

	// NOVO: estado para observações
	const [observacoes, setObservacoes] = useState({
		value: '',
		required: false,
	});

	// NOVO: estados para bloqueios de período
	const [blocks, setBlocks] = useState<
		{
			id: number;
			start_date: string;
			end_date: string;
			reason: string;
		}[]
	>([]);
	const [newBlockStartDate, setNewBlockStartDate] = useState('');
	const [newBlockEndDate, setNewBlockEndDate] = useState('');
	const [newBlockReason, setNewBlockReason] = useState('');
	const [loadingBlocks, setLoadingBlocks] = useState(true);

	// NOVO: estados para bloqueios de horários específicos
	const [intervals, setIntervals] = useState<
		{
			id: number;
			date: string;
			start_time: string;
			end_time: string;
			reason: string;
		}[]
	>([]);
	const [newIntervalDate, setNewIntervalDate] = useState('');
	const [newIntervalStartTime, setNewIntervalStartTime] = useState('');
	const [newIntervalEndTime, setNewIntervalEndTime] = useState('');
	const [newIntervalReason, setNewIntervalReason] = useState('');
	const [loadingIntervals, setLoadingIntervals] = useState(true);

	// NOVO: estados para intervalos simples (seção 1)
	const [simpleIntervals, setSimpleIntervals] = useState<
		{
			id: number;
			start_time: string;
			end_time: string;
		}[]
	>([]);
	const [
		newSimpleIntervalStartTime,
		setNewSimpleIntervalStartTime,
	] = useState('');
	const [newSimpleIntervalEndTime, setNewSimpleIntervalEndTime] = useState(
		'',
	);
	const [loadingSimpleIntervals, setLoadingSimpleIntervals] = useState(true);

	const [politicaDeAgendamento, setPoliticaDeAgendamento] = useState<{
		value: {
			value: string | number;
			label: string;
			selected: boolean;
		}[];
		required: boolean;
	}>({
		value: [
			{
				value: '0',
				label: 'Agendamento Livre',
				selected: true,
			},
			{
				value: '1',
				label:
					'Agendamento único com intervalo (Pode agendar uma vez, mas só pode agendar novamente depois do intervalo informado abaixo)',
				selected: false,
			},
			{
				value: '2',
				label:
					'Agendamento único permanente (Só pode agendar uma vez, sem possibilidade de reagendar)',
				selected: false,
			},
		],
		required: true,
	});

	const isBlockedInterval = React.useMemo(() => {
		return !politicaDeAgendamento.value[1].selected;
	}, [politicaDeAgendamento]);

	const [showRequiredBallon, setShowRequiredBallon] = useState(false);

	const currentFields = document.querySelectorAll(
		'input, select, textarea, button',
	);

	const lockFields = (fields: NodeListOf<Element>) => {
		fields.forEach(function (elField) {
			elField.setAttribute('disabled', '');
		});
	};

	const unlockFields = (fields: NodeListOf<Element>) => {
		fields.forEach(function (elField) {
			elField.removeAttribute('disabled');
		});
	};

	useEffect(() => {
		axios
			.get(urlEndpointGet, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then(function (response: typeResponseAxios) {
				const startTime = response.data.data.start_time.split(':');
				const endTime = response.data.data.end_time.split(':');
				const duration = response.data.data.event_range.split(':');

				setNome({
					value: response.data.data.name,
					required: nome.required,
				});
				setDevelopment({
					value: response.data.data.development_id || '',
					id: response.data.data.development_id,
					required: development.required,
				});
				setTempoDuracao({
					value: `${duration[0]}:${duration[1]}`,
					required: tempoDuracao.required,
				});
				setHorarioInicio({
					value: `${startTime[0]}:${startTime[1]}`,
					required: horarioInicio.required,
				});
				setHorarioFim({
					value: `${endTime[0]}:${endTime[1]}`,
					required: horarioFim.required,
				});
				setDataInicio({
					value: response.data.data.start_date,
					required: dataInicio.required,
				});
				setDataFim({
					value: response.data.data.end_date,
					required: dataFim.required,
				});
				setInterval({
					value: response.data.data.interval,
					required: intervalo.required,
				});
				setObservacoes({
					value: response.data.data.observation || '',
					required: observacoes.required,
				});
				setPoliticaDeAgendamento({
					value: [
						{
							value: '0',
							label: 'Agendamento Livre',
							selected: !response.data.data.unique,
						},
						{
							value: '1',
							label:
								'Agendamento único com intervalo (Pode agendar uma vez, mas só pode agendar novamente depois do intervalo informado abaixo)',
							selected: Boolean(response.data.data.unique),
						},
						{
							value: '2',
							label:
								'Agendamento único permanente (Só pode agendar uma vez, sem possibilidade de reagendar)',
							selected: Boolean(
								response.data.data.unique &&
									response.data.data.interval === 0,
							),
						},
					],
					required: true,
				});
			});

		// NOVO: buscar bloqueios existentes
		setLoadingBlocks(true);
		axios
			.get(urlEndpointGetBlocks, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then(function (response: typeResponseAxios) {
				if (response.data.success && response.data.data) {
					setBlocks(response.data.data);
				}
			})
			.catch(function (error) {
				console.error('Erro ao buscar bloqueios:', error);
			})
			.finally(() => {
				setLoadingBlocks(false);
			});

		// NOVO: buscar intervalos existentes
		setLoadingIntervals(true);
		axios
			.get(urlEndpointGetIntervals, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then(function (response: typeResponseAxios) {
				if (response.data.success && response.data.data) {
					// Tratar os dados dos intervalos para garantir formato correto
					const formattedIntervals = response.data.data.map(
						(interval: any) => ({
							...interval,
							date: Moment(interval.date).format('YYYY-MM-DD'),
							start_time: interval.start_time.substring(0, 5), // Remove segundos se houver
							end_time: interval.end_time.substring(0, 5), // Remove segundos se houver
						}),
					);
					setIntervals(formattedIntervals);
				}
			})
			.catch(function (error) {
				console.error('Erro ao buscar intervalos:', error);
			})
			.finally(() => {
				setLoadingIntervals(false);
			});

		// NOVO: buscar intervalos simples existentes
		setLoadingSimpleIntervals(true);
		axios
			.get(urlEndpointGetFakeIntervals, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then(function (response: typeResponseAxios) {
				if (response.data.success && response.data.data) {
					const formattedSimpleIntervals = response.data.data.map(
						(interval: any) => ({
							...interval,
							start_time: interval.start_time.substring(0, 5),
							end_time: interval.end_time.substring(0, 5),
						}),
					);
					setSimpleIntervals(formattedSimpleIntervals);
				}
			})
			.catch(function (error) {
				console.error('Erro ao buscar intervalos simples:', error);
			})
			.finally(() => {
				setLoadingSimpleIntervals(false);
			});
	}, []);

	const handleCadastrar = (e: React.FormEvent<HTMLInputElement>) => {
		e.preventDefault();

		setShowRequiredBallon(true);
		lockFields(currentFields);

		const politica = politicaDeAgendamento.value.filter(
			item => item.selected,
		)[0];

		const politicaNumber = Number(politica.value);

		axios
			.put(
				urlEndpointUpdate,
				{
					name: nome.value,
					short_description: descricao.value || 'Sem descrição',
					observation: observacoes.value || '',
					development_id: development.value,
					event_range: tempoDuracao.value,
					start_time: horarioInicio.value,
					end_time: horarioFim.value,
					open_after: dataInicio.value
						? Moment(dataInicio.value).format('YYYY-MM-DD')
						: null,
					close_before: dataFim.value
						? Moment(dataFim.value).format('YYYY-MM-DD')
						: null,
					unique: politicaNumber >= 1 ? 1 : 0,
					interval:
						politicaNumber === 2 ? 0 : Number(intervalo.value),
				},
				{
					headers: {
						Authorization: `Bearer ${token}`,
						'Content-Type': 'application/json',
					},
				},
			)
			.then(function (response: typeResponseAxios) {
				if (response.status > 200) {
					toast.success('Cadastro atualizado com sucesso!', {
						position: 'bottom-right',
						autoClose: 3000,
						hideProgressBar: true,
						closeOnClick: false,
						pauseOnHover: true,
						draggable: false,
						progress: undefined,
					});

					unlockFields(currentFields);
				}
			})
			.catch(function (error) {
				const errosServidor = error.response.data.error;
				toast.error(
					'Erro ao atualizar. Verifique os campos obrigatórios e tente novamente.',
					{
						position: 'bottom-right',
						autoClose: 3000,
						hideProgressBar: true,
						closeOnClick: false,
						pauseOnHover: true,
						draggable: false,
						progress: undefined,
					},
				);

				unlockFields(currentFields);
			});
	};

	// NOVO: adicionar bloqueio imediatamente na API
	const handleAddBlock = async () => {
		if (!newBlockStartDate) {
			toast.warn('Preencha Data Início do bloqueio.');
			return;
		}
		const start = Moment(newBlockStartDate, 'YYYY-MM-DD', true);
		if (!start.isValid()) {
			toast.warn('Data de início inválida.');
			return;
		}
		if (newBlockEndDate) {
			const end = Moment(newBlockEndDate, 'YYYY-MM-DD', true);
			if (!end.isValid()) {
				toast.warn('Data de fim inválida.');
				return;
			}
			if (end.isBefore(start)) {
				toast.warn(
					'Data de Fim não pode ser anterior à Data de Início.',
				);
				return;
			}
		}

		try {
			const response = await axios.post(
				urlEndpointCreateBlock,
				{
					start_date: Moment(newBlockStartDate).format('YYYY-MM-DD'),
					end_date: newBlockEndDate
						? Moment(newBlockEndDate).format('YYYY-MM-DD')
						: '',
					reason: newBlockReason || '',
				},
				{
					headers: {
						Authorization: `Bearer ${token}`,
						'Content-Type': 'application/json',
					},
				},
			);

			if (response.status === 201 || response.status === 200) {
				toast.success('Bloqueio adicionado com sucesso!');
				// Adicionar o novo bloqueio à lista local
				setBlocks(prev => [...prev, response.data.data]);
				setNewBlockStartDate('');
				setNewBlockEndDate('');
				setNewBlockReason('');
			}
		} catch (error: any) {
			toast.error('Erro ao adicionar bloqueio.');
		}
	};

	// NOVO: remover bloqueio da API
	const handleRemoveBlock = async (blockId: number) => {
		try {
			const response = await axios.delete(
				`${urlEndpoint}/calendars/${idRegister}/blocks/${blockId}`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				},
			);

			if (response.status === 200 || response.status === 204) {
				toast.success('Bloqueio removido com sucesso!');
				setBlocks(prev => prev.filter(b => b.id !== blockId));
			}
		} catch (error: any) {
			toast.error('Erro ao remover bloqueio.');
		}
	};

	// NOVO: adicionar intervalo imediatamente na API
	const handleAddInterval = async () => {
		if (!newIntervalDate) {
			toast.warn('Preencha a data do bloqueio de horário.');
			return;
		}
		if (!newIntervalStartTime) {
			toast.warn('Preencha o horário de início.');
			return;
		}
		if (!newIntervalEndTime) {
			toast.warn('Preencha o horário de fim.');
			return;
		}

		const date = Moment(newIntervalDate, 'YYYY-MM-DD', true);
		if (!date.isValid()) {
			toast.warn('Data inválida.');
			return;
		}

		// Validar formato de horário (HH:MM)
		const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
		if (!timeRegex.test(newIntervalStartTime)) {
			toast.warn('Horário de início inválido. Use o formato HH:MM.');
			return;
		}
		if (!timeRegex.test(newIntervalEndTime)) {
			toast.warn('Horário de fim inválido. Use o formato HH:MM.');
			return;
		}

		// Validar se horário de fim é posterior ao de início
		const startMoment = Moment(newIntervalStartTime, 'HH:mm');
		const endMoment = Moment(newIntervalEndTime, 'HH:mm');
		if (endMoment.isSameOrBefore(startMoment)) {
			toast.warn(
				'Horário de fim deve ser posterior ao horário de início.',
			);
			return;
		}

		try {
			const response = await axios.post(
				urlEndpointCreateInterval,
				{
					date: Moment(newIntervalDate).format('YYYY-MM-DD'),
					start_time: newIntervalStartTime,
					end_time: newIntervalEndTime,
					reason: newIntervalReason || '',
				},
				{
					headers: {
						Authorization: `Bearer ${token}`,
						'Content-Type': 'application/json',
					},
				},
			);

			if (response.status === 201 || response.status === 200) {
				toast.success('Bloqueio de horário adicionado com sucesso!');
				// Adicionar o novo intervalo à lista local
				setIntervals(prev => [...prev, response.data.data]);
				setNewIntervalDate('');
				setNewIntervalStartTime('');
				setNewIntervalEndTime('');
				setNewIntervalReason('');
			}
		} catch (error: any) {
			toast.error('Erro ao adicionar bloqueio de horário.');
		}
	};

	// NOVO: remover intervalo da API
	const handleRemoveInterval = async (intervalId: number) => {
		try {
			const response = await axios.delete(
				`${urlEndpoint}/calendars/${idRegister}/intervals/${intervalId}`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				},
			);

			if (response.status === 200 || response.status === 204) {
				toast.success('Bloqueio de horário removido com sucesso!');
				setIntervals(prev => prev.filter(i => i.id !== intervalId));
			}
		} catch (error: any) {
			toast.error('Erro ao remover bloqueio de horário.');
		}
	};

	// NOVO: adicionar intervalo simples imediatamente na API
	const handleAddSimpleInterval = async () => {
		if (!newSimpleIntervalStartTime) {
			toast.warn('Preencha o horário de início.');
			return;
		}
		if (!newSimpleIntervalEndTime) {
			toast.warn('Preencha o horário de fim.');
			return;
		}

		// Validar formato de horário (HH:MM)
		const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
		if (!timeRegex.test(newSimpleIntervalStartTime)) {
			toast.warn('Horário de início inválido. Use o formato HH:MM.');
			return;
		}
		if (!timeRegex.test(newSimpleIntervalEndTime)) {
			toast.warn('Horário de fim inválido. Use o formato HH:MM.');
			return;
		}

		// Validar se horário de fim é posterior ao de início
		const startMoment = Moment(newSimpleIntervalStartTime, 'HH:mm');
		const endMoment = Moment(newSimpleIntervalEndTime, 'HH:mm');
		if (endMoment.isSameOrBefore(startMoment)) {
			toast.warn(
				'Horário de fim deve ser posterior ao horário de início.',
			);
			return;
		}

		try {
			const response = await axios.post(
				urlEndpointCreateInterval,
				{
					date: null,
					start_time: newSimpleIntervalStartTime,
					end_time: newSimpleIntervalEndTime,
					reason: null,
				},
				{
					headers: {
						Authorization: `Bearer ${token}`,
						'Content-Type': 'application/json',
					},
				},
			);

			if (response.status === 201 || response.status === 200) {
				toast.success('Intervalo adicionado com sucesso!');
				// Adicionar o novo intervalo à lista local
				setSimpleIntervals(prev => [...prev, response.data.data]);
				setNewSimpleIntervalStartTime('');
				setNewSimpleIntervalEndTime('');
			}
		} catch (error: any) {
			toast.error('Erro ao adicionar intervalo.');
		}
	};

	// NOVO: remover intervalo simples da API
	const handleRemoveSimpleInterval = async (intervalId: number) => {
		try {
			const response = await axios.delete(
				`${urlEndpoint}/calendars/${idRegister}/intervals/${intervalId}`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				},
			);

			if (response.status === 200 || response.status === 204) {
				toast.success('Intervalo removido com sucesso!');
				setSimpleIntervals(prev =>
					prev.filter(i => i.id !== intervalId),
				);
			}
		} catch (error: any) {
			toast.error('Erro ao remover intervalo.');
		}
	};

	return (
		<BitPage>
			<BitHeaderFull
				label={`Atualizar  / Área Comum`}
				icon={''}
				hasIcon={false}
			/>

			<div className="p-5 mb-4 bg-white rounded">
				<h4 className="font-bold mb-4">ATUALIZAR ÁREA COMUM</h4>

				<h4 className="font-bold mb-4">
					<span className="bolinha-verde-numero">1</span>
					DADOS ÁREA COMUM
				</h4>

				<div className="bloco-campos-novo-cadastro">
					<div className="grid grid-cols-2 gap-4 mb-10">
						<BitInput
							label="Nome"
							type="text"
							placeholder="Digite..."
							classField="grupo-campo-novos-registros"
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setNome({
									value: e.currentTarget.value,
									required: true,
								})
							}
							value={nome.value}
							required={nome.required}
							showRequiredBallon={showRequiredBallon}
						/>
						<BitInput
							label="Tempo de Agendamento (Horas)"
							type="maskedinput"
							mask={[/\d/, /\d/, ':', /\d/, /\d/]}
							placeholder="Digite..."
							classField="grupo-campo-novos-registros"
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setTempoDuracao({
									value: e.currentTarget.value,
									required: true,
								})
							}
							value={tempoDuracao.value}
							required={tempoDuracao.required}
							showRequiredBallon={showRequiredBallon}
						/>
					</div>
					<div className="grid grid-cols-2 gap-4 mb-10">
						<BitInput
							label="Horário Abertura"
							type="maskedinput"
							mask={[/\d/, /\d/, ':', /\d/, /\d/]}
							placeholder="Digite..."
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setHorarioInicio({
									value: e.currentTarget.value,
									required: horarioInicio.required,
								})
							}
							value={horarioInicio.value}
							required={horarioInicio.required}
							showRequiredBallon={showRequiredBallon}
						/>
						<BitInput
							label="Horário Fechamento"
							type="maskedinput"
							mask={[/\d/, /\d/, ':', /\d/, /\d/]}
							placeholder="Digite..."
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setHorarioFim({
									value: e.currentTarget.value,
									required: horarioFim.required,
								})
							}
							value={horarioFim.value}
							required={horarioFim.required}
							showRequiredBallon={showRequiredBallon}
						/>
					</div>
					{/* NOVO: Subseção de Intervalos */}
					<div className="mb-10">
						<h5 className="font-semibold mb-4 text-gray-700">
							Intervalos
						</h5>
						<div className="grid grid-cols-3 gap-4 mb-4 items-end">
							<BitInput
								label="Horário de Início"
								type="maskedinput"
								mask={[/\d/, /\d/, ':', /\d/, /\d/]}
								placeholder="00:00"
								classField=""
								onChange={(
									e: React.FormEvent<HTMLInputElement>,
								) =>
									setNewSimpleIntervalStartTime(
										e.currentTarget.value,
									)
								}
								value={newSimpleIntervalStartTime}
								required={false}
								showRequiredBallon={false}
							/>
							<BitInput
								label="Horário de Fim"
								type="maskedinput"
								mask={[/\d/, /\d/, ':', /\d/, /\d/]}
								placeholder="00:00"
								classField=""
								onChange={(
									e: React.FormEvent<HTMLInputElement>,
								) =>
									setNewSimpleIntervalEndTime(
										e.currentTarget.value,
									)
								}
								value={newSimpleIntervalEndTime}
								required={false}
								showRequiredBallon={false}
							/>
							<div className="flex items-end">
								<BitButton
									text={'+'}
									buttonColor={'#3AABA2'}
									textColor={'#FFFFFF'}
									type={'fit px-4 py-2'}
									classesBlockOption={'inline-block'}
									onClick={handleAddSimpleInterval}
								/>
							</div>
						</div>

						{loadingSimpleIntervals ? (
							<div className="text-center py-4">
								<p className="text-gray-500">
									Carregando intervalos...
								</p>
							</div>
						) : simpleIntervals.length > 0 ? (
							<div className="overflow-x-auto mb-6">
								<table className="min-w-full text-left">
									<thead>
										<tr>
											<th className="px-2 py-2">
												Horário Início
											</th>
											<th className="px-2 py-2">
												Horário Fim
											</th>
											<th className="px-2 py-2">Ações</th>
										</tr>
									</thead>
									<tbody>
										{simpleIntervals.map((i, idx) => (
											<tr key={idx} className="border-t">
												<td className="px-2 py-2">
													{i.start_time}
												</td>
												<td className="px-2 py-2">
													{i.end_time}
												</td>
												<td className="px-2 py-2">
													<BitButton
														text={'REMOVER'}
														buttonColor={'#DC2626'}
														textColor={'#FFFFFF'}
														type={'fit px-4'}
														classesBlockOption={
															'inline-block'
														}
														onClick={() =>
															handleRemoveSimpleInterval(
																i.id,
															)
														}
													/>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						) : (
							<div className="text-center py-4">
								<p className="text-gray-500">
									Nenhum intervalo cadastrado.
								</p>
							</div>
						)}
					</div>
					<div className="grid grid-cols-2 gap-4 mb-10">
						<BitInput
							label="Data de Início"
							type="date"
							placeholder="Digite..."
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setDataInicio({
									value: e.currentTarget.value,
									required: dataInicio.required,
								})
							}
							value={dataInicio.value}
							required={dataInicio.required}
							showRequiredBallon={showRequiredBallon}
						/>
						<BitInput
							label="Data de Fim"
							type="date"
							placeholder="Digite..."
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setDataFim({
									value: e.currentTarget.value,
									required: dataFim.required,
								})
							}
							value={dataFim.value}
							required={dataFim.required}
							showRequiredBallon={showRequiredBallon}
						/>
					</div>
					<div className="mb-10">
						<BitInput
							label="Observações (opcional)"
							type="textarea"
							placeholder="Digite observações sobre a área comum..."
							classField=""
							onChange={(
								e: React.FormEvent<HTMLTextAreaElement>,
							) =>
								setObservacoes({
									value: e.currentTarget.value,
									required: observacoes.required,
								})
							}
							value={observacoes.value}
							required={observacoes.required}
							showRequiredBallon={showRequiredBallon}
						/>
					</div>
				</div>
				<h4 className="font-bold mb-4">
					<span className="bolinha-verde-numero">2</span>
					Política de Agendamento
				</h4>

				<div className="bloco-campos-novo-cadastro">
					<div className="mb-4">
						<BitInput
							label="Política"
							type="select"
							multipleSelect={false}
							placeholder=""
							valuesSelect={politicaDeAgendamento.value}
							classField="grupo-campo-novos-registros"
							onChange={(
								e: React.FormEvent<HTMLSelectElement>,
							) => {
								const allOptions = Object.entries(
									e.currentTarget.options,
								);
								const newValuePoliticaAgendamento: {
									value: string | number;
									label: string;
									selected: boolean;
								}[] = [];

								allOptions.map(option => {
									if (option[1].value !== '') {
										newValuePoliticaAgendamento.push({
											value: option[1].value,
											label: option[1].text,
											selected: option[1].selected,
										});
									}
									return null;
								});

								setPoliticaDeAgendamento({
									value: newValuePoliticaAgendamento,
									required: true,
								});
							}}
						/>
					</div>
					{!isBlockedInterval && (
						<div className="mb-4">
							<BitInput
								label="Intervalo"
								type="number"
								placeholder="Digite..."
								classField=""
								onChange={(
									e: React.FormEvent<HTMLInputElement>,
								) =>
									setInterval({
										value: e.currentTarget.value,
										required: intervalo.required,
									})
								}
								value={intervalo.value}
								required={
									intervalo.required || !isBlockedInterval
								}
								showRequiredBallon={showRequiredBallon}
								disabled={isBlockedInterval}
							/>
						</div>
					)}
				</div>

				{/* NOVO: Seção de Bloqueios de Período */}
				<h4 className="font-bold mb-4">
					<span className="bolinha-verde-numero">3</span>
					Bloqueios de Período
				</h4>
				<div className="bloco-campos-novo-cadastro">
					<div className="grid grid-cols-3 gap-4 mb-4">
						<BitInput
							label="Data de Início do Bloqueio"
							type="date"
							placeholder="Digite..."
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setNewBlockStartDate(e.currentTarget.value)
							}
							value={newBlockStartDate}
							required={false}
							showRequiredBallon={false}
						/>
						<BitInput
							label="Data de Fim do Bloqueio (opcional)"
							type="date"
							placeholder="Digite..."
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setNewBlockEndDate(e.currentTarget.value)
							}
							value={newBlockEndDate}
							required={false}
							showRequiredBallon={false}
						/>
						<BitInput
							label="Motivo (opcional)"
							type="text"
							placeholder="Digite..."
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setNewBlockReason(e.currentTarget.value)
							}
							value={newBlockReason}
							required={false}
							showRequiredBallon={false}
						/>
					</div>
					<div className="mb-6">
						<BitButton
							text={'ADICIONAR BLOQUEIO'}
							buttonColor={'#3AABA2'}
							textColor={'#FFFFFF'}
							type={'fit px-6'}
							classesBlockOption={'inline-block'}
							onClick={handleAddBlock}
						/>
					</div>

					{loadingBlocks ? (
						<div className="text-center py-8">
							<p className="text-gray-500">
								Carregando bloqueios...
							</p>
						</div>
					) : blocks.length > 0 ? (
						<div className="overflow-x-auto mb-6">
							<table className="min-w-full text-left">
								<thead>
									<tr>
										<th className="px-2 py-2">
											Data Início
										</th>
										<th className="px-2 py-2">Data Fim</th>
										<th className="px-2 py-2">Motivo</th>
										<th className="px-2 py-2">Ações</th>
									</tr>
								</thead>
								<tbody>
									{blocks.map((b, idx) => (
										<tr key={idx} className="border-t">
											<td className="px-2 py-2">
												{Moment(b.start_date).format(
													'DD/MM/YYYY',
												)}
											</td>
											<td className="px-2 py-2">
												{b.end_date
													? Moment(b.end_date).format(
															'DD/MM/YYYY',
													  )
													: '-'}
											</td>
											<td className="px-2 py-2">
												{b.reason}
											</td>
											<td className="px-2 py-2">
												<BitButton
													text={'REMOVER'}
													buttonColor={'#DC2626'}
													textColor={'#FFFFFF'}
													type={'fit px-4'}
													classesBlockOption={
														'inline-block'
													}
													onClick={() =>
														handleRemoveBlock(b.id)
													}
												/>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					) : (
						<div className="text-center py-8">
							<p className="text-gray-500">
								Nenhum bloqueio cadastrado.
							</p>
						</div>
					)}
				</div>

				{/* NOVO: Seção de Bloqueios de Horários */}
				<h4 className="font-bold mb-4">
					<span className="bolinha-verde-numero">4</span>
					Bloqueio de Horários
				</h4>
				<div className="bloco-campos-novo-cadastro">
					<div className="grid grid-cols-4 gap-4 mb-4">
						<BitInput
							label="Data do Bloqueio"
							type="date"
							placeholder="Digite..."
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setNewIntervalDate(e.currentTarget.value)
							}
							value={newIntervalDate}
							required={false}
							showRequiredBallon={false}
						/>
						<BitInput
							label="Horário de Início"
							type="maskedinput"
							mask={[/\d/, /\d/, ':', /\d/, /\d/]}
							placeholder="00:00"
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setNewIntervalStartTime(e.currentTarget.value)
							}
							value={newIntervalStartTime}
							required={false}
							showRequiredBallon={false}
						/>
						<BitInput
							label="Horário de Fim"
							type="maskedinput"
							mask={[/\d/, /\d/, ':', /\d/, /\d/]}
							placeholder="00:00"
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setNewIntervalEndTime(e.currentTarget.value)
							}
							value={newIntervalEndTime}
							required={false}
							showRequiredBallon={false}
						/>
						<BitInput
							label="Motivo (opcional)"
							type="text"
							placeholder="Digite..."
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setNewIntervalReason(e.currentTarget.value)
							}
							value={newIntervalReason}
							required={false}
							showRequiredBallon={false}
						/>
					</div>
					<div className="mb-6">
						<BitButton
							text={'ADICIONAR BLOQUEIO DE HORÁRIO'}
							buttonColor={'#3AABA2'}
							textColor={'#FFFFFF'}
							type={'fit px-6'}
							classesBlockOption={'inline-block'}
							onClick={handleAddInterval}
						/>
					</div>

					{loadingIntervals ? (
						<div className="text-center py-8">
							<p className="text-gray-500">
								Carregando bloqueios de horário...
							</p>
						</div>
					) : intervals.length > 0 ? (
						<div className="overflow-x-auto mb-6">
							<table className="min-w-full text-left">
								<thead>
									<tr>
										<th className="px-2 py-2">Data</th>
										<th className="px-2 py-2">
											Horário Início
										</th>
										<th className="px-2 py-2">
											Horário Fim
										</th>
										<th className="px-2 py-2">Motivo</th>
										<th className="px-2 py-2">Ações</th>
									</tr>
								</thead>
								<tbody>
									{intervals.map((i, idx) => (
										<tr key={idx} className="border-t">
											<td className="px-2 py-2">
												{Moment(i.date).format(
													'DD/MM/YYYY',
												)}
											</td>
											<td className="px-2 py-2">
												{i.start_time}
											</td>
											<td className="px-2 py-2">
												{i.end_time}
											</td>
											<td className="px-2 py-2">
												{i.reason}
											</td>
											<td className="px-2 py-2">
												<BitButton
													text={'REMOVER'}
													buttonColor={'#DC2626'}
													textColor={'#FFFFFF'}
													type={'fit px-4'}
													classesBlockOption={
														'inline-block'
													}
													onClick={() =>
														handleRemoveInterval(
															i.id,
														)
													}
												/>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					) : (
						<div className="text-center py-8">
							<p className="text-gray-500">
								Nenhum bloqueio de horário cadastrado.
							</p>
						</div>
					)}
				</div>

				<div className="text-right">
					<div className="inline-block mr-4">
						<BitLinkButton
							text={'VOLTAR'}
							buttonColor={'#3AABA2'}
							textColor={'#FFFFFF'}
							link={'/common-areas'}
						/>
					</div>
					<BitButton
						text={'FINALIZAR'}
						buttonColor={'#3AABA2'}
						textColor={'#FFFFFF'}
						type={'fit px-10'}
						classesBlockOption={'inline-block'}
						onClick={handleCadastrar}
					/>
				</div>

				<ToastContainer
					position="bottom-right"
					autoClose={2000}
					hideProgressBar
					newestOnTop={false}
					closeOnClick={false}
					rtl={false}
					pauseOnFocusLoss
					draggable={false}
					pauseOnHover
				/>
			</div>
		</BitPage>
	);
};

export default UpdateCommonArea;
